import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeNewbuildingBrokerCallbackWidget } from 'shared/actions/newbuildingBrokerOfferBooking';
import { selectCallbackWidgetOpened } from 'shared/selectors/newbuildingBrokerOfferBooking';

import { NewbuildingBrokerCallbackWidgetAdapterLoadable } from './NewbuildingBrokerCallbackWidgetAdapterLoadable';

/**
 * Контейнер модалки обратного звонка о бронировании.
 */
export const NewbuildingBrokerCallbackModalContainer = () => {
  const callbackWidgetOpened = useSelector(selectCallbackWidgetOpened);

  const dispatch = useDispatch();

  const handleModalClose = React.useCallback(() => {
    dispatch(closeNewbuildingBrokerCallbackWidget());
  }, [dispatch]);

  if (!callbackWidgetOpened) {
    return null;
  }

  return <NewbuildingBrokerCallbackWidgetAdapterLoadable open={callbackWidgetOpened} onClose={handleModalClose} />;
};
